export const ROUTE_PATHS = {
  HOME: '/',
} as const;

export interface ExecutiveSummary {
  title: string;
  date: string;
  summary: string;
  sources: string;
  themes: {
    title: string;
    description: string;
  }[];
}

export interface TransportSection {
  id: string;
  type: 'road' | 'ocean' | 'air' | 'macro';
  title: string;
  summary: string;
  detailedContent: string;
  highlights: string[];
  source: string;
  image: string;
  metrics?: {
    label: string;
    value: string;
    isPositive?: boolean;
  }[];
}

export interface CompetitiveUpdate {
  title: string;
  content: string;
  updates: {
    title: string;
    description: string;
  }[];
  source: string;
}

export interface MarketInsight {
  executiveSummary: ExecutiveSummary;
  transportSections: TransportSection[];
  competition: CompetitiveUpdate;
}

export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);
};

export const formatPercentage = (value: number): string => {
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
};
